<template>
  <div>
    <v-snackbar
      v-for="(notify, index) in notifys"
      :bottom="notify.position.includes('bottom')"
      :right="notify.position.includes('right')"
      :top="notify.position.includes('top')"
      :left="notify.position.includes('left')"
      :centered="notify.position.includes('centered')"
      multi-line
      :key="notify.key"
      :value="true"
      :style="[{ 'margin-bottom': calcMargin(index) }]"
      :color="notify.color"
      :timeout="notify.timeout"
      @input="closeNotify(notify)"
    >
      <div class="d-flex justify-space-between align-center">
        <span v-html="notify.text"></span>
        <v-btn icon @click="closeNotify(notify)">
          <v-icon color="white" size="lg">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'Notify',

    computed: {
      notifys() {
        let allNotifys = []

        // Формирование обычных notify
        for (let i = 0; i < this.$store.state.general?.notify?.length; i++) {
          const currentNotify = this.$store.state.general.notify[i]

          const newNotify = this.generateNotify('notify', currentNotify)
          allNotifys.push(newNotify)
        }

        // Формирование error notify
        for (let i = 0; i < this.$store.state.general?.error?.length; i++) {
          const currentError = this.$store.state.general.error[i]

          const newNotify = this.generateNotify('error', currentError)
          allNotifys.push(newNotify)
        }
        return allNotifys.length < 3 ? allNotifys : allNotifys.slice(0, 3)
      }
    },

    methods: {
      // Генерация структуры нового notify по типу
      generateNotify(type, item) {
        // notify из сторы может быть в формате {text: '', color: ''}
        const isNotifyObject = typeof item === 'object'

        const defaultColorByType = { 'error': 'error', 'notify': 'secondary' }
        // Если notify в сторе объект у которого указан цвет - берём его или дэфолтный для каждого типа notify
        const color = item.color ? item.color : defaultColorByType[type]
        const text = item.text || item
        const key = `${this.generateRandom()}`
        const position = item.position ? item.position : ['bottom', 'right']
        item.position = position
        let timeout = item.timeout ? item.timeout * 1000 : 5000
        item.timeout = timeout

        // Если ошибка записанная в стору - объект
        if (isNotifyObject) {

          return { ...item, text, type, key, color }
        }

        return { type, color, key, text, position, timeout }
      },

      // Вычисление нижних отступов между notify
      calcMargin(i) {
        return i * 80 + 'px'
      },

      closeNotify(notify) {
        this.$store.commit('DELETE_NOTIFY', notify)
      },
      
      generateRandom() {
        if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
          const a = new Uint32Array(1)
          window.crypto.getRandomValues(a)
          return a[0] / 2 ** 32
        }
        return 0.5
      }
    }
  }
</script>
